import * as THREE from 'three';

// 近接インタラクションの距離（メートル）
export const INTERACT_DISTANCE = 1.9;

// 商品ラベルをcanvasで描く（外部画像に依存しない＝CORS問題なし）
function makeLabelTexture(product) {
  const canvas = document.createElement('canvas');
  canvas.width = 256;
  canvas.height = 340;
  const ctx = canvas.getContext('2d');

  // クラフト紙風の背景
  ctx.fillStyle = '#e8dcc4';
  ctx.fillRect(0, 0, 256, 340);
  ctx.strokeStyle = 'rgba(78, 58, 40, 0.25)';
  ctx.lineWidth = 2;
  ctx.strokeRect(8, 8, 240, 324);

  // 上部の深緑バンド
  ctx.fillStyle = '#1a3a2a';
  ctx.fillRect(8, 8, 240, 64);
  ctx.fillStyle = '#e8dcc4';
  ctx.font = '20px "Cormorant Garamond", serif';
  ctx.textAlign = 'center';
  ctx.fillText('GURI COFFEE', 128, 48);

  // 商品名
  ctx.fillStyle = '#1a3a2a';
  ctx.font = 'bold 26px "Noto Sans JP", sans-serif';
  ctx.fillText(product.nameJa, 128, 140);
  ctx.font = '15px "Cormorant Garamond", serif';
  ctx.fillStyle = '#7a6a4f';
  ctx.fillText(product.name, 128, 168);

  // 区切り線
  ctx.strokeStyle = '#b89d5a';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(64, 195);
  ctx.lineTo(192, 195);
  ctx.stroke();

  // 容量・価格
  ctx.fillStyle = '#4e3a28';
  ctx.font = '17px "Noto Sans JP", sans-serif';
  ctx.fillText(product.weight, 128, 235);
  ctx.fillStyle = '#1a3a2a';
  ctx.font = 'bold 24px "Noto Sans JP", sans-serif';
  ctx.fillText(product.price, 128, 280);

  const tex = new THREE.CanvasTexture(canvas);
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.anisotropy = 4;
  return tex;
}

// コーヒーバッグ1つ分のメッシュ（グループ）を作る
function makeCoffeeBag(product) {
  const group = new THREE.Group();

  const labelTex = makeLabelTexture(product);
  const kraft = new THREE.MeshStandardMaterial({ color: 0xd9cbae, roughness: 0.85 });
  const label = new THREE.MeshStandardMaterial({ map: labelTex, roughness: 0.8 });

  // 本体（正面 +z にラベル）
  const body = new THREE.Mesh(
    new THREE.BoxGeometry(0.22, 0.3, 0.12),
    [kraft, kraft, kraft, kraft, label, kraft]
  );
  body.position.y = 0.15;
  body.castShadow = true;
  group.add(body);

  // 上部の折り返し
  const fold = new THREE.Mesh(new THREE.BoxGeometry(0.23, 0.035, 0.05), kraft);
  fold.position.y = 0.315;
  fold.castShadow = true;
  group.add(fold);

  // 足元のハイライトリング（近接時のみ表示）
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.16, 0.2, 32),
    new THREE.MeshBasicMaterial({ color: 0xb89d5a, transparent: true, opacity: 0.85, side: THREE.DoubleSide })
  );
  ring.rotation.x = -Math.PI / 2;
  ring.position.y = 0.005;
  ring.visible = false;
  group.add(ring);

  return { group, ring };
}

/**
 * 商品を棚に配置する。
 * 返り値: interactables — { id, type, data, position, setHighlight(bool) } の配列
 */
export function createProducts(scene, productsData, anchors) {
  return productsData.map((product, i) => {
    const anchor = anchors[i % anchors.length];
    const { group, ring } = makeCoffeeBag(product);
    group.position.copy(anchor.position);
    group.rotation.y = anchor.rotationY;
    scene.add(group);

    return {
      id: product.id,
      type: 'product',
      label: product.nameJa,
      data: product,
      position: group.position.clone(),
      setHighlight: (on) => {
        ring.visible = on;
      },
    };
  });
}

/**
 * プレイヤー位置から一番近いインタラクト対象を返す（範囲外なら null）
 */
export function findNearest(interactables, playerPos) {
  let best = null;
  let bestDist = INTERACT_DISTANCE;
  for (const it of interactables) {
    const dx = it.position.x - playerPos.x;
    const dz = it.position.z - playerPos.z;
    const d = Math.hypot(dx, dz);
    if (d < bestDist) {
      best = it;
      bestDist = d;
    }
  }
  return best;
}
